module.exports = __webpack_public_path__ + "img/title-mobile.56241b85.png";